<template>
    <shop-modal-contract v-if="contractItem" :item="contractItem"/>
    <shop-modal-service v-if="serviceItem" :item="serviceItem"/>
</template>

<script>
    import ShopModalContract from "./ShopModalContract";
    import ShopModalService from "./ShopModalService";
    export default {
        name: "ShopModalItem",
        components: {ShopModalService, ShopModalContract},
        computed: {
            serviceItem: function(){
                return this.$store.getters.shopItemServiceModal;
            },
            contractItem: function(){
                return this.$store.getters.shopItemContractModal;
            },
        }
    }
</script>